import React, { useEffect, useState } from "react";
import { post } from "../../../Services/ApiHandler";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import AlertTypes from "./AlertTypes";
import AlertEscalation from "./AlertEscalation";
import AlertIndTypes from "./AlertIndTypes";
import AlertTypesAndCamera from "./AlertTypesAndCamera";
import AlertIndEscalation from "./AlertIndEscalation";
import SelectBox from "../../../components/SelectBox";
import StatusComp from "../../../components/StatusComp";
import { URL } from "../../../Services/Constant";
import { search_icon } from "../../../assets/imgs";
import AlertTypesAndCameraNew from "./AlertTypesAndCameraNew";
import { storedPermissions } from "../../../components/storedPermissions";

const AlertAndCamera = () => {
  const location = useLocation();
  const tab = location?.state?.tab;
  const givenpermissions = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );
  const [selectedItem, setSelectedItem] = useState({});
  const [site, setSite] = useState({});
  const [comapanyList, setCompanyList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [activeTab, setActiveTab] = useState(
    tab
      ? tab
      : givenpermissions?.includes("CAN-List-KNF_ADMIN_ALERT_TYPE")
        ? "types"
        : givenpermissions?.includes("CAN-List-KNF_CAMERA")
          ? "camera"
          : "escalation",
  );
  const [alertData, setAlertData] = useState([]);
  const [alertDataType, setAlertDataType] = useState([]);
  const [alertDatas, setAlertDatas] = useState([]);
  const data_admin = location?.state?.data;
  const [selected, setSelected] = useState([]);
  const [initialSelected, setInitialSelected] = useState([]);
  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [siteData, setSiteData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [btn, setBtn] = useState(false);
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  const adminType = true;
  const ind = "ind";

  let path = location?.pathname;

  console.log("path----->", path);

  console.log("adminType------>", adminType);
  console.log("alertDataType-->", alertDataType);

  useEffect(() => {
    if (tab) return;
    const stored = localStorage.getItem("types");
    if (stored) {
      setActiveTab(JSON.parse(stored));
    } else {
      setActiveTab("types");
      localStorage.setItem("types", JSON.stringify("types"));
    }
  }, []);

  const handleTab = (type) => {
    setActiveTab(type);
  };

  const getCompanyList = () => {
    post(URL.COMPANY_LIST_ADMIN, {})
      .then((res) => {
        setCompanyList(res?.companies);
        setSiteList([]);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company_id) => {
    console.log("company_id", company_id);
    setSelectedCompany(company_id);
    let formdata = new FormData();
    formdata.append("company_id", company_id?.value);
    post(URL.ACTIVE_ADMIN_SITE, formdata)
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        } else {
          setSiteList([]);
          setSite({});
          setAlertData([]);
          setAlertDataType([]);
          setAlertDatas([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAlert = (site_id, alert_type) => {
    if (site_id) {
      let formdata = new FormData();
      formdata.append("site_id", site_id);
      post(URL.ALERT_TYPE_LIST, formdata)
        .then((res) => {
          let temp = [];
          console.log("res", res);

          alert_type?.map((item, ind) => {
            let finder = res?.alert_type?.find((i) => i?.name == item?.name);
            if (finder?.id) {
              temp.push({
                ...item,
                severity: finder?.severity,
              });
            } else {
              temp.push(item);
            }
          });

          if (res?.alert_type?.length > 0) {
            setAlertData(temp);
          } else {
            setAlertData(alert_type);
          }
          console.log("res?.alert_type", res?.alert_type);
          setAlertDataType(res?.alert_type);
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertData([]);
    }
  };

  const getAlertCam = (site_id) => {
    if (site_id) {
      let formdata = new FormData();
      formdata.append("site_id", site_id);
      post(URL.ALERT_TYPE_LIST, formdata)
        .then((res) => {
          if (res?.status == "success") {
            setAlertDataType(res?.alert_type);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertDataType([]);
    }
  };

  const getAlertTypes = (site_id) => {
    setSite(site_id);
    if (site_id) {
      let formdata = new FormData();
      if (adminType) {
        formdata.append("site_id", site_id);
      } else {
        formdata.append("site_id", site_id?.value);
      }

      let url_ = adminType ? URL.ADMIN_ALERT_TYPES : URL.ALERT_TYPE_LIST;

      post(url_, formdata)
        .then((res) => {
          if (res?.alert_type?.length > 0) {
            if (adminType) {
              getAlert(site_id, res?.alert_type);
            } else {
              setAlertData(res?.alert_type);
            }
            if (res?.selected_alert_type_ids?.length > 0) {
              setSelected(res?.selected_alert_type_ids);
              setInitialSelected(res?.selected_alert_type_ids);
            }
          } else {
            setAlertData([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertData([]);
    }
  };

  const getAlertEscalation = (site_id) => {
    setSite(site_id);
    if (site_id) {
      let formdata = new FormData();
      if (adminType) {
        formdata.append("site_id", site_id);
      } else {
        formdata.append("site_id", site_id?.value);
      }

      post(URL.ALERT_ESCALATIONS_LIST, formdata)
        .then((res) => {
          if (res?.alert_escalation?.length > 0) {
            setAlertDatas(res?.alert_escalation);
          } else {
            setAlertDatas([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertDatas([]);
    }
  };

  useEffect(() => {
    getCompanyList();
  }, []);

  console.log("acticeTab", activeTab);

  // console.log("selected", selected);
  console.log("adminType", adminType);

  const selectAlertTypes = () => {
    let formdata = new FormData();
    formdata.append("site_id", selectedOption?.value);
    selected?.map((item, ind) => {
      formdata.append(`alert_type_id[${ind}]`, item);
    });
    setBtn(true);

    let url = adminType ? `${URL.UPDATE_ALERT_TYPES}s` : URL.UPDATE_ALERT_TYPES;
    console.log("url----->url", url);
    // return;
    post(url, formdata)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);

          setInitialSelected(selected);

          setTimeout(() => {
            getAlertTypes(selectedOption?.value);
          }, 300);
        } else {
          setSelected(initialSelected);
        }
        setBtn(false);
      })
      .catch((err) => {
        setBtn(false);
        console.log("errResponse", err);
      });
  };

  const handleTabSwich = (event) => {
    getAlertTypes(event);
    getAlertEscalation(event);
  };

  useEffect(() => {
    if (activeTab === "camera" && selectedOption?.value) {
      getAlertCam(selectedOption?.value);
    }
  }, [activeTab]);

  const canSelect =
    givenpermissions?.includes("CAN-View-KNF_ADMIN_ALERT_TYPE") ||
    givenpermissions?.includes("CAN-View-KNF_CAMERA");

  return (
    <div className="dashRightView">
      <StatusComp name={"Alert Types And Camera"} hide={true} />
      <div className={`d-flex w-100 ac-js mb-4 gap-5`}>
        {/* Company Select */}

        {canSelect && (
          <div>
            <label className="form-label">Select Company</label>
            <SelectBox
              arrayData={comapanyList}
              data={company}
              setData={setCompany}
              selectedOption={selectedCompany}
              setSelectedOption={(val) => {
                getSiteList(val);
                setSelectedOption(null);
                setAlertData([]);
                setList([]);
              }}
              style={true}
              isClearable={false}
            />
          </div>
        )}

        {/* Site Select */}

        {canSelect && (
          <div className=" mx-4">
            <label className="form-label">Select Site</label>
            <SelectBox
              arrayData={siteList}
              data={siteData}
              setData={setSiteData}
              selectedOption={selectedOption}
              setSelectedOption={(val) => {
                setSelectedOption(val);
                //   console.log("val", val);
                setAlertData([]);
                setAlertDataType([]);
                setAlertDatas([]);
                setSelected([]);
                setInitialSelected([]);
                getAlertTypes(val?.value);
                getAlertEscalation(val?.value);
                getAlertCam(val?.value);
              }}
              disabled={selectedCompany?.label ? false : true}
              style={true}
              isClearable={false}
            />
          </div>
        )}
      </div>
      <div
        className={`tab-header d-flex gap-3 mb-3 ${
          !selectedOption?.value && "opacity-25"
        }`}
      >
        {givenpermissions?.includes("CAN-List-KNF_ADMIN_ALERT_TYPE") && (
          <button
            className={`tab-btn ${activeTab === "types" ? "active" : ""}`}
            onClick={() => handleTab("types")}
          >
            Alert Types
          </button>
        )}

        {givenpermissions?.includes("CAN-List-KNF_ALERT_ESCALATION") && (
          <button
            className={`tab-btn ${activeTab === "escalation" ? "active" : ""}`}
            onClick={() => handleTab("escalation")}
          >
            Alert Escalation Time
          </button>
        )}

        {givenpermissions?.includes("CAN-List-KNF_CAMERA") && (
          <button
            className={`tab-btn ${activeTab === "camera" ? "active" : ""}`}
            onClick={() => handleTab("camera")}
          >
            Camera
          </button>
        )}
      </div>

      <div className={!selectedOption?.value && "opacity-25"}>
        {activeTab === "types" && (
          <>
            {/* {storedPermissions?.includes("CAN-Add-KNF_ADMIN_ALERT_TYPE") && ( */}
            <AlertIndTypes
              editable={false}
              alertData={alertData}
              setAlertData={setAlertData}
              selected={selected}
              setSelected={setSelected}
              selectAlertTypes={selectAlertTypes}
              btn={btn}
            />
            {/* )} */}
          </>
        )}
        {activeTab === "escalation" && (
          <AlertIndEscalation
            editable={true}
            // editable={editable}
            site={site}
            alertData={alertDatas}
            setAlertData={setAlertDatas}
          />
        )}
        {activeTab === "camera" && (
          <>
            {/* {storedPermissions?.includes("CAN-Add-KNF_ADMIN_ALERT_TYPE") && ( */}
            <AlertTypesAndCameraNew
              editable={true}
              site={site}
              alertData={alertDataType}
              setAlertData={setAlertDataType}
              data={selectedOption?.value}
              selected={selected}
              list={list}
              setList={setList}
            />
            {/* )} */}
          </>
        )}
      </div>
    </div>
  );
};

export default AlertAndCamera;
